import { StatCell } from './stat-cell'
import { SummaryCardDivider } from './summary-card-divider'
import { SummaryCardShell } from './summary-card-shell'

interface Props {
  completedCount: number
  missedCount: number
  leadingCount?: number
  leadingLabel?: string
}

export function AppointmentStatsCard({
  completedCount,
  missedCount,
  leadingCount,
  leadingLabel = 'Total Scheduled',
}: Props) {
  return (
    <SummaryCardShell className="items-stretch gap-4">
      {leadingCount !== undefined && (
        <>
          <StatCell label={leadingLabel} value={leadingCount} />
          <SummaryCardDivider />
        </>
      )}
      <StatCell label="Completed Appts" value={completedCount} />
      <SummaryCardDivider />
      <StatCell label="Missed Appts" value={missedCount} valueClassName="text-[28px] text-orange" />
    </SummaryCardShell>
  )
}
